var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Footermobile"},[_c('a',{attrs:{"href":"/m-dist/index.html#"}},[_vm._v("切换手机版")])])}]

export { render, staticRenderFns }